// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"133":"50b10337b4adc686","174":"3af3f0cfc63eb05f","233":"7743954d043c4714","300":"f8138d9482f8145c","350":"34fda9cf5bc3abaa","363":"f1d18a87ef6c53b8","406":"9254f71a6db020f7","728":"2712a6cf0e97fa28","905":"502152ca98218deb"}[chunkId] + ".js";
};